<template>
    <!-- most of this is also in the product view template -->
    <div class="product_options-list-wrap product_options-list-secondary">
        <h4 class="product_options-heading product_options-heading-details">{{ productName }}</h4>
        <div class="product_options-details">
            <div class="product_details-details">
                <!-- using div with style instead of image because we it doesn't show the last image while waiting for the current one to load -->
                <div v-if="img"
                     class="product_details-image-wrap"
                     :style="{ 'background-image': 'url('+img+')' }"
                     :title="imgAlt"></div>
                <div>
                    <div v-if="hasPrimaryProperty">
                        <strong>{{ properties[0].shortName }}:</strong>
                        {{ primaryProperty.value }}
                    </div>
                    <div v-if="hasSecondProperty">
                        <strong>{{ properties[1].shortName }}:</strong>
                        {{ secondaryProperty.value }}
                    </div>
                    <div>
                        <strong>Part Number:</strong>
                        {{ partNumberResolved }}
                    </div>
                    <div>
                        <strong>Sold per:</strong>
                        {{ soldPer }}
                    </div>
                    <div v-if="hasFullUnitPricing">
                        <strong>Full Unit Quantity:</strong>
                        {{ fullUnitQuantity }}
                    </div>
                    <!-- @todo should we display this as regular & bulk price (ie <100 & >100) -->
                    <div v-if="priceResolved">
                        <strong>{{ priceResolved | price }}</strong>
                    </div>

                    <cart-add v-if="priceResolved"
                              :product-id="productId"
                              :product-variant-id="productVariantId"
                              :separate-order-product="separateOrderProduct"
                              :minimum-quantity="minimumQuantity"
                              :full-unit-quantity="fullUnitQuantity"
                              @quantity="updateQuantity"
                              class="product-input_wrap" />
                </div>
            </div>

            <!-- also in Product/view -->
            <div v-if="!priceResolved" class="product_details-note">
                To purchase this product, you need to
                <a :href="loginUrl" rel="nofollow">login</a> or
                <a :href="registerUrl">register for an account</a>.
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        productId: {
            type: Number,
            required: true,
        },
        productVariantId: {
            type: Number,
        },
        productName: {
            type: String,
            required: true,
        },
        partNumber: {
            type: String,
        },
        soldPer: {
            type: String,
        },
        price: {
            type: Number,
        },
        properties: {
            type: Array,
            default: () => {
                return [];
            },
        },
        primaryProperty: {
            type: Object,
        },
        secondaryProperty: {
            type: Object,
        },
        bulkQuantity: {
            type: Number,
        },
        bulkPrice: {
            type: Number,
        },
        fullUnitQuantity: {
            type: Number,
        },
        fullUnitPrice: {
            type: Number,
        },
        separateOrderProduct: {
            type: Boolean,
            required: true,
        },
        minimumQuantity: {
            type: Number,
            required: true,
        },
    },

    data () {
        return {
            hasProperties: this.properties.length > 0,
            quantity: 1,
        };
    },

    computed: {
        ...mapState({
            loginUrl: state => state.serverData.urls.login,
            registerUrl: state => state.serverData.urls.register,
        }),
        img () {
            if (!this.hasProperties) {
                return null;
            }

            if (this.primaryProperty.large) {
                return this.primaryProperty.large;
            } else if (this.secondaryProperty && this.secondaryProperty.large) {
                return this.secondaryProperty.large;
            }

            return null;
        },
        imgAlt () {
            if (!this.hasProperties) {
                return null;
            }

            if (this.primaryProperty.large) {
                return this.primaryProperty.value;
            } else if (this.secondaryProperty && this.secondaryProperty.large) {
                return this.secondaryProperty.value;
            }

            return null;
        },
        hasPrimaryProperty () {
            return this.properties.length > 0;
        },
        hasSecondProperty () {
            return this.properties.length > 1;
        },
        partNumberResolved () {
            if (!this.hasProperties) {
                return this.partNumber;
            }

            if (this.primaryProperty.partNumber) {
                return this.primaryProperty.partNumber;
            } else if (this.secondaryProperty && this.secondaryProperty.partNumber) {
                return this.secondaryProperty.partNumber;
            }

            return null;
        },
        // integer / cents
        priceResolved () {
            let priceKey = 'price';
            if (this.hasBulkPricing && this.quantity >= this.bulkQuantity) {
                priceKey = 'bulkPrice';
            }
            if (this.hasFullUnitPricing && 0 === this.quantity % this.fullUnitQuantity) {
                priceKey = 'fullUnitPrice';
            }

            if (!this.hasProperties) {
                return this[priceKey];
            }

            if (this.primaryProperty[priceKey]) {
                return this.primaryProperty[priceKey];
            } else if (this.secondaryProperty && this.secondaryProperty[priceKey]) {
                return this.secondaryProperty[priceKey];
            }

            return null;
        },

        hasBulkPricing () {
            return null !== this.bulkQuantity;
        },
        hasFullUnitPricing () {
            return null !== this.fullUnitQuantity;
        },
    },

    methods: {
        updateQuantity (quantity) {
            this.quantity = quantity;
        },
    },
}
</script>
